import React, { FC, useCallback } from "react";
import AntdTextArea, { TextAreaProps } from "antd/es/input/TextArea";

interface Props extends Omit<TextAreaProps, "onChange"> {
  maxLines?: number;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

const TextArea: FC<Props> = ({ maxLines = 2, onChange, ...props }) => {
  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      let value = e.target.value;
      if (maxLines) {
        const lines = value.split("\n");
        if (lines.length > maxLines) {
          value = lines.slice(0, maxLines).join("\n");
        }
      }
      e.target.value = value;
      onChange(e);
    },
    [maxLines, onChange]
  );

  return (
    <AntdTextArea
      {...props}
      onChange={handleChange}
      onKeyDown={(e) => {
        if (maxLines && e.key === "Enter") {
          const currentLines = (e.target as HTMLTextAreaElement).value.split(
            "\n"
          ).length;
          if (currentLines >= maxLines) {
            e.preventDefault();
          }
        }
      }}
    />
  );
};

export default TextArea;
